import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
//import { apiCall } from "src/_apiConfig/apiCall";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";

export const InputControl = (props) => {
  return (
    <CCol xl={4} className="mt-3">
      <CLabel htmlFor={props.id}>{props.label}</CLabel>
      <CInput
        value={props.value === null ? " " : props.value}
        disabled
        id={props.id}
      />
    </CCol>
  );
};

export const DocumentControl = (props) => {
  return (
    <CCol xl={4}>
      <CLabel> {props.label} </CLabel>
      {props.viewUserDocuments !== undefined &&
      props.viewUserDocuments !== null &&
      props.path !== undefined &&
      props.path !== "" &&
      props.path !== null ? (
        <a
          className="ml-2"
          target="_blank"
          href={`${props.downloadUrl}/Documents/UserDocument/${props.viewUserDocuments.userId}/${props.path}`}
          //href={props.href}
          rel="noreferrer"
        >
          View
        </a>
      ) : (
        ""
      )}
    </CCol>
  );
};

const BidderListView = () => {
  let history = useHistory();

  let { userId } = useParams();
  const [viewBidderDetails, setviewBidderDetails] = useState();
  const [showList, setshowList] = useState();
  const [viewUserDocuments, setviewUserDocuments] = useState();

  const getBidderDetails = async () => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `Bidder/getBidder?userId=${userId}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setviewBidderDetails(jsonobj);
      setshowList(true);
    }
  };
  const getUserDocument = async () => {
    const header = new Headers();
    setshowList(false);
    const response = await apiCall(
      `User/GetUserDocument?userid=${userId}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setviewUserDocuments(jsonobj);
    }
  };

  useEffect(() => {
    getBidderDetails();
    getUserDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <>
      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        <CCardHeader>
          <CRow className="pt-3" xl={12}>
            <CCol xl={10}>
              <h3>Bidder Details</h3>
            </CCol>
          </CRow>
          <hr />
          <div className="">
            <CRow>
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Email Address :"}
                value={viewBidderDetails.emailId}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Mobile No.:"}
                value={viewBidderDetails.mobile}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Alter Email :"}
                value={viewBidderDetails.alternateEmail}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Goods and Services :"}
                value={viewBidderDetails.gst}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Propritor Name :"}
                value={viewBidderDetails.directorName}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Father Name :"}
                value={viewBidderDetails.lastName}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"House No :"}
                value={viewBidderDetails.houseNo}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Street Location :"}
                value={viewBidderDetails.streetName}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Area Landmark :"}
                value={viewBidderDetails.area}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Company City :"}
                value={viewBidderDetails.city}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"District Union :"}
                value={viewBidderDetails.disctrict}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"State Name :"}
                value={viewBidderDetails.state}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Pincode :"}
                value={viewBidderDetails.pincode}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Contact No 1 :"}
                value={viewBidderDetails.contact1}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Contact Number 2 :"}
                value={viewBidderDetails.contact2}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Contact Number 3 :"}
                value={viewBidderDetails.contact3}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Fax Number :"}
                value={viewBidderDetails.fax}
              />
            </CRow>

            <CRow xl={12} className="pt-3 ">
              <CCol xl={10}>
                <h3>Company Details</h3>
              </CCol>
            </CRow>
            <hr />
            <CRow className="mt-3">
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Company Name :"}
                value={viewBidderDetails.companyName}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Tender Category :"}
                value={viewBidderDetails.categoryName}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Pan Card : "}
                value={viewBidderDetails.pan}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Registration Details : "}
                value={viewBidderDetails.registrationDetails}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Name of Forest Division Where Tenderer Registered : "}
                value={viewBidderDetails.registeredDistrict}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Status of Tenderer : "}
                value={viewBidderDetails.companyType}
              />
            </CRow>
            <CRow xl={12} className="pt-3 ">
              <CCol xl={10}>
                <h3>Bidder Capacity</h3>
              </CCol>
            </CRow>
            <hr />
            <CRow className="mt-3">
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Tenderers Bank Details : "}
                value={viewBidderDetails.bankAccountType}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Accounter Name : "}
                value={viewBidderDetails.accountNumber}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Bank Branch : "}
                value={viewBidderDetails.bankBranch}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"IFS Code : "}
                value={viewBidderDetails.ifscCode}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={"Emd Amount : "}
                value={viewBidderDetails.emdAmount}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Purchase Capacity : "}
                value={viewBidderDetails.purchaseCapacity}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={"Bidding Capacity : "}
                value={viewBidderDetails.biddingCapacity}
              />
            </CRow>
            <CRow xl={12} className="pt-3 ">
              <CCol xl={10}>
                <h3>Company Directors</h3>
              </CCol>
            </CRow>
            <hr />
            <CRow className="mt-3">
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName1}
              />

              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName2}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName3}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName4}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName5}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName6}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName7}
              />
              <InputControl
                id={"exampleFormControlInput1"}
                label={" Name of the Directors : "}
                value={viewBidderDetails.directorName8}
              />
            </CRow>
            <CRow xl={12} className="pt-3 ">
              <CCol xl={10}>
                <h3>User Documents</h3>
              </CCol>
            </CRow>
            <hr />
            <CRow>
              <DocumentControl
                label={"Pan Card :"}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.pancardpath}
              />
              <DocumentControl
                label={"Aadhar Card :"}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.aadharcardpath}
              />
              <CCol xl={4}></CCol>
            </CRow>
            <CRow>
              <DocumentControl
                label={"ITR1 :"}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.itr1path}
              />
              <DocumentControl
                label={"ITR2 :"}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.itr2path}
              />
              <DocumentControl
                label={"ITR3 :"}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.itr3path}
              />
            </CRow>
            <CRow>
              <DocumentControl
                label={"GSTIN Certificate : "}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.gstincertificatepath}
              />

              <DocumentControl
                label={"DFO Registration Certificate : "}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.dforegistrationcertificatepath}
              />

              <DocumentControl
                label={"Scanned copy of Partnership Firm : "}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.scannedcopyofpartnershipfirmpath}
              />
            </CRow>
            <CRow>
              <DocumentControl
                label={
                  " Scanned copy of Certificate of Company Incorporation of Latest Directors of company, AOA and MOA :"
                }
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.moapath}
              />
              <DocumentControl
                label={
                  "Scanned copy of list of family members in case of H.U.F.:"
                }
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.hufpath}
              />
              <DocumentControl
                label={"Any other related document : "}
                viewUserDocuments={viewUserDocuments}
                downloadUrl={downloadUrl}
                path={viewUserDocuments?.otherdocument}
              />
            </CRow>

            <CButton
              className="mt-2 mb-2"
              color="success"
              onClick={() => history.goBack()}
            >
              Go Back
            </CButton>
          </div>
        </CCardHeader>
      )}
    </>
  );
};
export default BidderListView;
